import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertConfig($input: ConfigInput) {
    upsertConfig(input: $input) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = []

  setErrors(errors)
  return errors.length === 0
}

export const useSaveConfig = onSuccess => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Config', 'Configs'], client: generalClient })
  const modalData = useModalData()
  const closeModal = useCloseModal()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      const input = cleanRequest(form, modalData)
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
